import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { cn } from '@/components/ui';

/** Root props for placeholder / layout widgets — mirrors a styled `div` surface. */
export type WidgetSurfaceProps = Omit<ComponentPropsWithoutRef<'div'>, 'children'> & {
  children?: ReactNode;
};

/**
 * Root class contract for every widget: `widget` + `widget--<id>` (see `styles/widget/_surfaces.css`).
 * Pass a stable kebab-case `widgetId` per component file.
 */
export function widgetSurfaceClass(widgetId: string, className?: string): string {
  return cn('widget', `widget--${widgetId}`, className);
}
